<div [ngClass]="isSuccessPage ? 'footer footer-success' : 'footer'">
  <div class="aligned-footer-content">
    <img src="/assets/images/box.svg" alt="box" />
    <p class="text-one">{{ "Footer.One" | translate }}</p>
  </div>
  <div class="aligned-footer-content">
    <img src="/assets/images/question.svg" alt="question" />
    <p class="text-two">{{ "Footer.Two" | translate }} <a href="mailto:info@alkesoccer.com">info@alkesoccer.com</a></p>
  </div>
  <div class="green-block">
    <div class="green-block__content">
      <div class="left">
        <a href="https://alkesoccer.com/en/contact" target="_blank">
          {{ "Contact" | translate }}
        </a>
        <a href="https://alkesoccer.com/en/page/conditions-utilisation" target="_blank">
          {{ "Footer.TermsAndConditions" | translate }}
        </a>
        <a href="https://alkesoccer.com/en/page/politique-de-confidentialite" target="_blank">
          {{ "Footer.PrivacyPolicy" | translate }}
        </a>
        <a href="https://alkesoccer.com/" target="_blank">
          {{ "Footer.BackTo" | translate }}
        </a>
      </div>
      <div class="right">
        <span>
          {{ "Footer.FindUs" | translate }}
        </span>
        <div class="icon-container">
          <a target="_blank" href="https://www.facebook.com/alkesoccer">
            <img src="/assets/images/facebook-logo.svg" class="icon" alt="" />
          </a>
          <a target="_blank" href="https://www.instagram.com/alkesoccer/">
            <img src="/assets/images/instagram.svg" class="icon" alt="" />
          </a>
          <a target="_blank" href="https://twitter.com/alkesoccer">
            <img src="/assets/images/twitter.png" class="icon" alt="" />
          </a>
        </div>
      </div>
      <div class="right-rr">

      </div>
    </div>
  </div>
</div>